// import cobalt js

// TODO: come up with automated solution for aggregating modules, this sucks.
const cobaltModules = [
    "AccountMerge",
    "Achievement",
    "AdminPanel",
    "Advertising",
    "Announcement",
    "Attachment",
    "Auth",
    "Avatar",
    "BetterTimeSpanField",
    "Billing",
    "BulkModeration",
    "BunnyEars",
    "CMS",
    "Collapse",
    "Comment",
    "Constants",
    "Core",
    "Countdown",
    "CP",
    "CPAdvertising",
    "CPBan",
    "CPCaching",
    "CPForumThreadPrefix",
    "CPNotifications",
    "CPSiteSettings",
    "CPSkinManager",
    "CPUserProfileTitle",
    "DateTimeField",
    "DayTimeSelector",
    "Dice",
    "Expandable",
    "ExportImportSettings",
    "Favorites",
    "Feedback",
    "FieldLists",
    "Filters",
    "flot",
    "Forms",
    "Forum",
    "ForumFilters",
    "ForumManager",
    "ForumThreadForm",
    "Gallery",
    "ImageManager",
    "ImageTagging",
    "Infractions",
    "LegacyPayment",
    "Listing",
    "Localization",
    "LocalizationEditor",
    // ViewState must initialize before Markup and MarkupEditor
    "ViewState",
    "Markup",
    "MarkupEditor",
    "Modal",
    "ModelMultipleSymbolicField",
    "ModPositions",
    "MultiFileUpload",
    "Navigation",
    "NavigationEditor",
    "NavigationItem",
    "NavigationManager",
    "NewContent",
    "NiceDates",
    "Notifications",
    "PageBlock",
    "PageRegion",
    "PageStructureManager",
    "Permissions",
    "Poll",
    "PollingThrottle",
    "PopOut",
    "PostWidget",
    "ProfileFields",
    "QueryParser",
    "Rating",
    "Reports",
    "Roles",
    "Routes",
    "Shoutbox",
    "Smilies",
    "Social",
    "Social_Facebook",
    "Social_Twitter",
    "SourcePoint",
    "StickyElement",
    "Tabs",
    "Tags",
    "TemplateAndSkin",
    "Throttle",
    "TinyMCE",
    "UI",
    "User",
    "UserContentManager",
    "UserManagement",
    "UserProfile",
    "UserSurrogateAvatars",
    "UserTitles",
    "Utils",
    "VideoEmbed",
    "VoiceWidget",
    "Warning",
    "WarningNotification",
    "Widget",
    "WidgetSettings",
    // typescript>javascript includes
    "Analytics",
    "Burger",
    "Footer",
    "Tidbit",
    "PrivateMessage",
    "Table",
    "CPJobs",
    "Mobile",
    "MurmurHash2",
    "NavigationLists",
    "HomePage",
    "ResponsiveUtility",
    "MobileAdvertising", //? not in CoreScripts, not referenced afaik, remove?
    "Device"
];

require("./Cobalt/Cobalt.js");

cobaltModules.forEach((module) => {
    require(`./Cobalt/Cobalt.${module}.js`);
});

// include prototype extensions
// TODO: investigate removing these. some are polyfills, some are non-standard.
require("./PrototypeExtensionsEntry.js");


// WEBPACK FOOTER //
// ./content/js/CobaltEntry.js